import React from "react";

export const srcSetOf = (url) =>
  url && url.endsWith("-1600.webp") ? `${url.replace("-1600.webp", "-800.webp")} 800w, ${url} 1600w` : undefined;

export function ArtistPhoto({ src, alt, position, sizes = "(max-width: 768px) 100vw, 33vw", className = "", ...rest }) {
  if (!src) return <div className="w-full h-full bg-gradient-to-br from-[#1a1a1d] to-black" aria-label={alt} />;
  return (
    <img src={src} srcSet={srcSetOf(src)} sizes={sizes} alt={alt} loading="lazy" decoding="async"
      style={{ objectPosition: position || "50% 30%" }} className={`w-full h-full object-cover ${className}`} {...rest} />
  );
}

export function ArtistOverlay() {
  return (
    <>
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/55 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-3/5 bg-gradient-to-t from-black/95 via-black/70 to-transparent" />
    </>
  );
}
